export default __webpack_public_path__ + "static/media/Nxrmal_Lo_Hoodie_Normal.f582d447.tga";